import gql from 'graphql-tag';

const GET_ENABLED_LOCATIONS = gql`
  query enabledLocations {
    enabledLocations {
      location {
        id
        tag
      }
      status
      versions
    }
  }
`;

const COMPARE_LOCATION_VERSIONS = gql`
  mutation compareLocationVersions($tag: String!) {
    compareLocationVersions(tag: $tag)
  }
`;

const CLOSE_STORAGE_REPORT = gql`
  mutation closeStorageReport {
    closeStorageReport {
      id
    }
  }
`;

const GET_LOCATION_VERSIONS = gql`
  query locationVersions($tag: String!) {
    locationVersions(tag: $tag) {
      id
      user {
        id
        name
      }
      products {
        productCode
        boxes
        totalPieces
        pieces
        batch
        expiryDate
        upc
      }
    }
  }
`;

const GET_INCIDENCES = gql`
  query incidences($tag: String!) {
    incidences(tag: $tag) {
      productCode
      upc
      batch
      expiryDate
      pieces
    }
  }
`;

export {
  GET_ENABLED_LOCATIONS,
  COMPARE_LOCATION_VERSIONS,
  CLOSE_STORAGE_REPORT,
  GET_LOCATION_VERSIONS,
  GET_INCIDENCES,
};
